import { Component, Input, OnInit } from '@angular/core';
import {
  BbbRoom,
  FsPortalFile,
  PresentationFileMetadata,
} from '@reflact/kick';
import { BbbService } from 'src/app/bbb.service';

@Component({
  selector: 'app-presentation-editor',
  templateUrl: './presentation-editor.component.html',
  styles: [],
})
export class PresentationEditorComponent implements OnInit {
  @Input() public room: BbbRoom;
  public presentations: FsPortalFile<PresentationFileMetadata>[];
  constructor(public service: BbbService) { }

  public async ngOnInit() {
    await this.loadPresentations();
  }

  public async deletePresentation(presentationId: string) {
    await this.service.deletePresentation(presentationId);
    const index = this.presentations.findIndex(
      (presentation) => presentation._id === presentationId,
    );
    this.presentations.splice(index, 1);
  }

  public async onUpload(event: Event) {
    const element = event.target as HTMLInputElement;
    const fileList: File[] = Array.from(element.files);
    for (const file of fileList) {
      if (file.type === 'application/pdf') {
        try {
          await this.service.uploadFile(file, this.room._id);
          await this.loadPresentations();
        } catch (error) {
          console.error(error);
        }
      }
    }
  }

  private async loadPresentations() {
    this.presentations = await this.service.getPresentations(this.room._id);
  }
}